/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { HiMicrophone, HiLockClosed } from "react-icons/hi";
import { FiGithub, FiMail, FiMessageSquare, FiExternalLink } from "react-icons/fi";
import "./Support.css";

export default function Support({ onBack }) {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("submitting");
    
    fetch("http://localhost:5000/api/auth/support", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(data => {
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    })
    .catch(err => {
      console.error(err);
      setStatus("error");
    });
  };

  return (
    <div className="page-wrap support-page">
      {/* ── NAVBAR ── */}
      <nav className="nav">
        <div className="nav-brand" style={{ cursor: "pointer" }} onClick={onBack}>
          <div className="nav-logo"><HiMicrophone size={16}/></div>
          <span className="nav-name">VoiceForge</span>
        </div>
        <div className="nav-links">
          <button className="nav-link" onClick={onBack}>Home</button>
          <button className="nav-link active">Support</button>
        </div>
        <div className="nav-end">
          <a href="https://github.com/fahadalimazari" target="_blank" rel="noreferrer" className="nav-icon-btn" title="GitHub"><FiGithub size={14}/></a>
          <button className="nav-cta" onClick={onBack}>← Back to Home</button>
        </div>
      </nav>

      {/* ── MAIN LAYOUT ── */}
      <div className="support-hero-bg">
        <div className="support-glow-blob" />
        <div className="support-layout-inner">
          <div className="support-header-section">
            <div className="support-badge"><span className="support-dot"></span>Active Customer Support</div>
            <h1 className="support-title">How can we help you?</h1>
            <p className="support-subtitle">Have questions about voice generation, models, or getting started? Send our developer team a message.</p>
          </div>

          <div className="support-grid">
            {/* Left: Contact Form Card */}
            <div className="support-card form-card">
              <h2 className="card-heading"><FiMessageSquare size={16} style={{color:"#8B5CF6"}}/> Submit Support Ticket</h2>
              <p className="card-subheading">Fill in details below and we will get back to you within 24 hours.</p>

              {status === "success" && <div className="alert success">🎉 Thank you! Your ticket has been submitted successfully.</div>}
              {status === "error" && <div className="alert error">⚠️ Something went wrong. Please try again.</div>}

              <form onSubmit={handleSubmit} className="support-form">
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" name="name" required value={formData.name} onChange={handleChange} placeholder="John Doe" style={{background: "#09090b", color: "#fff"}} />
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" name="email" required value={formData.email} onChange={handleChange} placeholder="john@example.com" style={{background: "#09090b", color: "#fff"}} />
                </div>
                <div className="form-group">
                  <label>Your Message / Issue Details</label>
                  <textarea name="message" required rows="6" value={formData.message} onChange={handleChange} placeholder="Describe what you need help with... (e.g. Model path issues, audio sample cloning error)" style={{background: "#09090b", color: "#fff"}}></textarea>
                </div>
                <button type="submit" disabled={status === "submitting"} className="submit-btn">
                  {status === "submitting" ? "Sending Ticket..." : "Submit Ticket"}
                </button>
              </form>
            </div>

            {/* Right: Quick Help Info Cards */}
            <div className="support-sidebar">
              <div className="support-card info-card">
                <h3 className="sidebar-title"><FiMail size={14}/> Direct Email</h3>
                <p className="sidebar-desc">Get in touch directly via email for business inquiries or collaboration details.</p>
                <a href="mailto:fahadalimazari25@gmail.com" className="sidebar-link">fahadalimazari25@gmail.com</a>
              </div>

              <div className="support-card info-card">
                <h3 className="sidebar-title"><HiLockClosed size={14}/> 100% Private & Secure</h3>
                <p className="sidebar-desc">VoiceForge runs on our secure cloud infrastructure. Your text scripts, voices, and audio outputs are private and never stored or shared.</p>
              </div>

              <div className="support-card info-card">
                <h3 className="sidebar-title"><FiGithub size={14}/> Open Source Code</h3>
                <p className="sidebar-desc">View source repositories, submit feature requests, or report issues on GitHub.</p>
                <a href="https://github.com/fahadalimazari" target="_blank" rel="noreferrer" className="sidebar-link inline-flex">
                  Developer GitHub Profile <FiExternalLink size={12} style={{marginLeft: 4}}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
